import React from 'react';
import { Container } from 'react-bootstrap';
import useModal from '../../hooks/useModal';
import Button from '../Button';
import { Address } from './AddressForm';
import AddressFormModal from './AddressFormModal';

const testAdress: Address = {
  type: 'home',
  address1: '',
  address2: '',
  city: '',
  state: '',
  zipCode: '',
};

function AddressFormDemo({ children }: any) {
  const [showModal, handleShow, handleClose] = useModal();

  const [address] = React.useState<Address>(testAdress);

  const handleSubmit = () => {
    console.log('submit', address);
  };

  return (
    <Container>
      <Container className="mt-10">
        <h4>Address Form Modal</h4>
        <Container className="d-flex justify-content-between flex-wrap align-items-center p-0">
          <Button variant="primary" onMouseDown={handleShow}>
            Add address
          </Button>
          <AddressFormModal
            showModal={showModal}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            existingAddress={address}
          />
        </Container>
      </Container>
    </Container>
  );
}

export default AddressFormDemo;
